/**
 * @flow
 */

// System errors xx

export const ERROR_BAD_REQUEST: number = 1;
export const ERROR_LOGIN_REQUIRED: number = 2;
export const ERROR_NEW_CLIENT_IN_SESSION: number = 3;
export const ERROR_FORBIDDEN: number = 4;
export const ERROR_TIMEOUT: number = 5;
export const ERROR_RELATION_ERROR: number = 6;
export const ERROR_INTERNAL_SERVER_ERROR: number = 7;
export const ERROR_SESSION_IS_TERMINATED: number = 8;
export const ERROR_NICKNAME_REQUIRED: number = 9;
export const ERROR_FLOOD_REQUEST: number = 10;

// User errors 1xx , 101xx

export const ERROR_USER_REGISTER_BAD_PAYLOAD: number = 100;
export const ERROR_USER_REGISTER_INTERNAL_SERVER_ERROR: number = 101;
export const ERROR_USER_REGISTER_BLOCKED_USER: number = 135;
export const ERROR_USER_REGISTER_MAX_TRY_LOCK: number = 136;
export const ERROR_USER_REGISTER_MAX_SEND_LOCK: number = 137;

export const ERROR_USER_VERIFY_BAD_PAYLOAD: number = 102;
export const ERROR_USER_VERIFY_INTERNAL_SERVER_ERROR: number = 103;
export const ERROR_USER_VERIFY_USER_NOT_FOUND: number = 104;
export const ERROR_USER_VERIFY_BLOCKED_USER: number = 105;
export const ERROR_USER_VERIFY_INVALID_CODE: number = 106;
export const ERROR_USER_VERIFY_EXPIRED_CODE: number = 107;
export const ERROR_USER_VERIFY_MAX_TRY_LOCK: number = 108;
export const ERROR_USER_VERIFY_TWO_STEP_VERIFICATION_ENABLED: number = 184;

export const ERROR_USER_LOGIN_BAD_PAYLOAD: number = 109;
export const ERROR_USER_LOGIN_INTERNAL_SERVER_ERROR: number = 110;
export const ERROR_USER_LOGIN_FAILED: number = 111;
export const ERROR_USER_LOGIN_ALREADY_LOGGED_IN: number = 10170;

export const ERROR_USER_PROFILE_SET_NICKNAME_BAD_PAYLOAD: number = 112;
export const ERROR_USER_PROFILE_SET_NICKNAME_INTERNAL_SERVER_ERROR: number = 113;

export const ERROR_USER_PROFILE_SET_EMAIL_BAD_PAYLOAD: number = 114;
export const ERROR_USER_PROFILE_SET_EMAIL_INTERNAL_SERVER_ERROR: number = 115;

export const ERROR_USER_PROFILE_SET_GENDER_BAD_PAYLOAD: number = 116;
export const ERROR_USER_PROFILE_SET_GENDER_INTERNAL_SERVER_ERROR: number = 117;

export const ERROR_USER_CONTACTS_IMPORT_BAD_PAYLOAD: number = 118;
export const ERROR_USER_CONTACTS_IMPORT_INTERNAL_SERVER_ERROR: number = 119;
export const ERROR_USER_CONTACTS_IMPORT_FORBIDDEN: number = 10169;

export const ERROR_USER_CONTACTS_GET_LIST_BAD_PAYLOAD: number = 120;
export const ERROR_USER_CONTACTS_GET_LIST_INTERNAL_SERVER_ERROR: number = 121;

export const ERROR_USER_CONTACTS_DELETE_BAD_PAYLOAD: number = 122;
export const ERROR_USER_CONTACTS_DELETE_INTERNAL_SERVER_ERROR: number = 123;

export const ERROR_USER_CONTACTS_EDIT_BAD_PAYLOAD: number = 124;
export const ERROR_USER_CONTACTS_EDIT_INTERNAL_SERVER_ERROR: number = 125;

export const ERROR_USER_PROFILE_GET_NICKNAME_BAD_PAYLOAD: number = 126;
export const ERROR_USER_PROFILE_GET_NICKNAME_INTERNAL_SERVER_ERROR: number = 127;

export const ERROR_USER_PROFILE_GET_EMAIL_BAD_PAYLOAD: number = 128;
export const ERROR_USER_PROFILE_GET_EMAIL_INTERNAL_SERVER_ERROR: number = 129;

export const ERROR_USER_PROFILE_GET_GENDER_BAD_PAYLOAD: number = 130;
export const ERROR_USER_PROFILE_GET_GENDER_INTERNAL_SERVER_ERROR: number = 131;

export const ERROR_USER_AVATAR_ADD_BAD_PAYLOAD: number = 138;
export const ERROR_USER_AVATAR_ADD_INTERNAL_SERVER_ERROR: number = 139;
export const ERROR_USER_AVATAR_ADD_FORBIDDEN: number = 140;

export const ERROR_USER_AVATAR_DELETE_BAD_PAYLOAD: number = 141;
export const ERROR_USER_AVATAR_DELETE_INTERNAL_SERVER_ERROR: number = 142;
export const ERROR_USER_AVATAR_DELETE_FORBIDDEN: number = 143;

export const ERROR_USER_AVATAR_GET_LIST_BAD_PAYLOAD: number = 144;
export const ERROR_USER_AVATAR_GET_LIST_INTERNAL_SERVER_ERROR: number = 145;
export const ERROR_USER_AVATAR_GET_LIST_FORBIDDEN: number = 146;

export const ERROR_USER_INFO_BAD_PAYLOAD: number = 147;
export const ERROR_USER_INFO_INTERNAL_SERVER_ERROR: number = 148;
export const ERROR_USER_INFO_FORBIDDEN: number = 149;

export const ERROR_USER_GET_DELETE_TOKEN_BAD_PAYLOAD: number = 150;
export const ERROR_USER_GET_DELETE_TOKEN_INTERNAL_SERVER_ERROR: number = 151;
export const ERROR_USER_GET_DELETE_TOKEN_MAX_TRY_LOCK: number = 152;
export const ERROR_USER_GET_DELETE_TOKEN_MAX_SEND_LOCK: number = 153;

export const ERROR_USER_DELETE_BAD_PAYLOAD: number = 154;
export const ERROR_USER_DELETE_INTERNAL_SERVER_ERROR: number = 155;
export const ERROR_USER_DELETE_INVALID_TOKEN: number = 156;
export const ERROR_USER_DELETE_EXPIRED_TOKEN: number = 157;
export const ERROR_USER_DELETE_MAX_TRY_LOCK: number = 158;

export const ERROR_USER_PROFILE_GET_SELF_REMOVE_BAD_PAYLOAD: number = 159;
export const ERROR_USER_PROFILE_GET_SELF_REMOVE_INTERNAL_SERVER_ERROR: number = 160;

export const ERROR_USER_PROFILE_SET_SELF_REMOVE_BAD_PAYLOAD: number = 161;
export const ERROR_USER_PROFILE_SET_SELF_REMOVE_INTERNAL_SERVER_ERROR: number = 162;

export const ERROR_USER_PROFILE_CHECK_USERNAME_INTERNAL_SERVER_ERROR: number = 163;

export const ERROR_USER_PROFILE_UPDATE_USERNAME_BAD_PAYLOAD: number = 164;
export const ERROR_USER_PROFILE_UPDATE_USERNAME_INTERNAL_SERVER_ERROR: number = 165;
export const ERROR_USER_PROFILE_UPDATE_USERNAME_UPDATE_LOCK: number = 175;

export const ERROR_USER_UPDATE_STATUS_BAD_PAYLOAD: number = 166;
export const ERROR_USER_UPDATE_STATUS_INTERNAL_SERVER_ERROR: number = 167;

export const ERROR_USER_SESSION_GET_ACTIVE_LIST_BAD_PAYLOAD: number = 168;
export const ERROR_USER_SESSION_GET_ACTIVE_LIST_INTERNAL_SERVER_ERROR: number = 169;

export const ERROR_USER_SESSION_TERMINATE_BAD_PAYLOAD: number = 170;
export const ERROR_USER_SESSION_TERMINATE_INTERNAL_SERVER_ERROR: number = 171;
export const ERROR_USER_SESSION_TERMINATE_FORBIDDEN: number = 172;

export const ERROR_USER_SESSION_LOGOUT_BAD_PAYLOAD: number = 173;
export const ERROR_USER_SESSION_LOGOUT_INTERNAL_SERVER_ERROR: number = 174;

export const ERROR_USER_CONTACTS_BLOCK_BAD_PAYLOAD: number = 176;
export const ERROR_USER_CONTACTS_BLOCK_INTERNAL_SERVER_ERROR: number = 177;
export const ERROR_USER_CONTACTS_BLOCK_USER_NOT_FOUND: number = 178;

export const ERROR_USER_CONTACTS_UNBLOCK_BAD_PAYLOAD: number = 179;
export const ERROR_USER_CONTACTS_UNBLOCK_INTERNAL_SERVER_ERROR: number = 180;
export const ERROR_USER_CONTACTS_UNBLOCK_ALREADY_UNBLOCKED: number = 181;

export const ERROR_USER_CONTACTS_GET_BLOCKED_LIST_BAD_PAYLOAD: number = 182;
export const ERROR_USER_CONTACTS_GET_BLOCKED_LIST_INTERNAL_SERVER_ERROR: number = 183;

export const ERROR_USER_TWO_STEP_VERIFICATION_GET_PASSWORD_DETAIL_BAD_PAYLOAD: number = 185;
export const ERROR_USER_TWO_STEP_VERIFICATION_GET_PASSWORD_DETAIL_INTERNAL_SERVER_ERROR: number = 186;
export const ERROR_USER_TWO_STEP_VERIFICATION_GET_PASSWORD_DETAIL_FORBIDDEN: number = 187;
export const ERROR_USER_TWO_STEP_VERIFICATION_GET_PASSWORD_DETAIL_NO_PASSWORD: number = 188;

export const ERROR_USER_TWO_STEP_VERIFICATION_VERIFY_PASSWORD_BAD_PAYLOAD: number = 189;
export const ERROR_USER_TWO_STEP_VERIFICATION_VERIFY_PASSWORD_INTERNAL_SERVER_ERROR: number = 190;
export const ERROR_USER_TWO_STEP_VERIFICATION_VERIFY_PASSWORD_MAX_TRY_LOCK: number = 191;
export const ERROR_USER_TWO_STEP_VERIFICATION_VERIFY_PASSWORD_FORBIDDEN: number = 192;
export const ERROR_USER_TWO_STEP_VERIFICATION_VERIFY_PASSWORD_NO_PASSWORD: number = 193;
export const ERROR_USER_TWO_STEP_VERIFICATION_VERIFY_PASSWORD_INVALID_PASSWORD: number = 194;

export const ERROR_USER_TWO_STEP_VERIFICATION_SET_PASSWORD_BAD_PAYLOAD: number = 195;
export const ERROR_USER_TWO_STEP_VERIFICATION_SET_PASSWORD_INTERNAL_SERVER_ERROR: number = 196;
export const ERROR_USER_TWO_STEP_VERIFICATION_SET_PASSWORD_MAX_TRY_LOCK: number = 197;
export const ERROR_USER_TWO_STEP_VERIFICATION_SET_PASSWORD_INVALID_OLD_PASSWORD: number = 198;

export const ERROR_USER_TWO_STEP_VERIFICATION_UNSET_PASSWORD_BAD_PAYLOAD: number = 199;
export const ERROR_USER_TWO_STEP_VERIFICATION_UNSET_PASSWORD_INTERNAL_SERVER_ERROR: number = 10100;
export const ERROR_USER_TWO_STEP_VERIFICATION_UNSET_PASSWORD_MAX_TRY_LOCK: number = 10101;
export const ERROR_USER_TWO_STEP_VERIFICATION_UNSET_PASSWORD_INVALID_PASSWORD: number = 10102;

export const ERROR_USER_TWO_STEP_VERIFICATION_CHECK_PASSWORD_BAD_PAYLOAD: number = 10103;
export const ERROR_USER_TWO_STEP_VERIFICATION_CHECK_PASSWORD_INTERNAL_SERVER_ERROR: number = 10104;
export const ERROR_USER_TWO_STEP_VERIFICATION_CHECK_PASSWORD_INVALID_PASSWORD: number = 10105;
export const ERROR_USER_TWO_STEP_VERIFICATION_CHECK_PASSWORD_MAX_TRY_LOCK: number = 10106;
export const ERROR_USER_TWO_STEP_VERIFICATION_CHECK_PASSWORD_NO_PASSWORD: number = 10107;

export const ERROR_USER_TWO_STEP_VERIFICATION_VERIFY_RECOVERY_EMAIL_BAD_PAYLOAD: number = 10108;
export const ERROR_USER_TWO_STEP_VERIFICATION_VERIFY_RECOVERY_EMAIL_INTERNAL_SERVER_ERROR: number = 10109;
export const ERROR_USER_TWO_STEP_VERIFICATION_VERIFY_RECOVERY_EMAIL_MAX_TRY_LOCK: number = 10110;
export const ERROR_USER_TWO_STEP_VERIFICATION_VERIFY_RECOVERY_EMAIL_EXPIRED_TOKEN: number = 10111;
export const ERROR_USER_TWO_STEP_VERIFICATION_VERIFY_RECOVERY_EMAIL_NO_PASSWORD: number = 10112;
export const ERROR_USER_TWO_STEP_VERIFICATION_VERIFY_RECOVERY_EMAIL_INVALID_TOKEN: number = 10113;

export const ERROR_USER_TWO_STEP_VERIFICATION_CHANGE_RECOVERY_EMAIL_BAD_PAYLOAD: number = 10114;
export const ERROR_USER_TWO_STEP_VERIFICATION_CHANGE_RECOVERY_EMAIL_INTERNAL_SERVER_ERROR: number = 10115;
export const ERROR_USER_TWO_STEP_VERIFICATION_CHANGE_RECOVERY_EMAIL_MAX_TRY_LOCK: number = 10116;
export const ERROR_USER_TWO_STEP_VERIFICATION_CHANGE_RECOVERY_EMAIL_NO_PASSWORD: number = 10117;
export const ERROR_USER_TWO_STEP_VERIFICATION_CHANGE_RECOVERY_EMAIL_INVALID_PASSWORD: number = 10118;
export const ERROR_USER_TWO_STEP_VERIFICATION_CHANGE_RECOVERY_EMAIL_CONFIRMED_BEFORE: number = 10119;

export const ERROR_USER_TWO_STEP_VERIFICATION_REQUEST_RECOVERY_TOKEN_BAD_PAYLOAD: number = 10120;
export const ERROR_USER_TWO_STEP_VERIFICATION_REQUEST_RECOVERY_TOKEN_INTERNAL_SERVER_ERROR: number = 10121;
export const ERROR_USER_TWO_STEP_VERIFICATION_REQUEST_RECOVERY_TOKEN_NO_PASSWORD: number = 10122;
export const ERROR_USER_TWO_STEP_VERIFICATION_REQUEST_RECOVERY_TOKEN_NO_RECOVERY_EMAIL: number = 10123;
export const ERROR_USER_TWO_STEP_VERIFICATION_REQUEST_RECOVERY_TOKEN_MAX_TRY_LOCK: number = 10124;
export const ERROR_USER_TWO_STEP_VERIFICATION_REQUEST_RECOVERY_TOKEN_FORBIDDEN: number = 10154;

export const ERROR_USER_TWO_STEP_VERIFICATION_RECOVER_PASSWORD_BY_TOKEN_BAD_PAYLOAD: number = 10125;
export const ERROR_USER_TWO_STEP_VERIFICATION_RECOVER_PASSWORD_BY_TOKEN_INTERNAL_SERVER_ERROR: number = 10126;
export const ERROR_USER_TWO_STEP_VERIFICATION_RECOVER_PASSWORD_BY_TOKEN_MAX_TRY_LOCK: number = 10127;
export const ERROR_USER_TWO_STEP_VERIFICATION_RECOVER_PASSWORD_BY_TOKEN_EXPIRED_TOKEN: number = 10128;
export const ERROR_USER_TWO_STEP_VERIFICATION_RECOVER_PASSWORD_BY_TOKEN_INVALID_TOKEN: number = 10129;
export const ERROR_USER_TWO_STEP_VERIFICATION_RECOVER_PASSWORD_BY_TOKEN_NO_PASSWORD: number = 10130;
export const ERROR_USER_TWO_STEP_VERIFICATION_RECOVER_PASSWORD_BY_TOKEN_FORBIDDEN: number = 10155;

export const ERROR_USER_TWO_STEP_VERIFICATION_RECOVER_PASSWORD_BY_ANSWERS_BAD_PAYLOAD: number = 10131;
export const ERROR_USER_TWO_STEP_VERIFICATION_RECOVER_PASSWORD_BY_ANSWERS_INTERNAL_SERVER_ERROR: number = 10132;
export const ERROR_USER_TWO_STEP_VERIFICATION_RECOVER_PASSWORD_BY_ANSWERS_MAX_TRY_LOCK: number = 10133;
export const ERROR_USER_TWO_STEP_VERIFICATION_RECOVER_PASSWORD_BY_ANSWERS_INVALID_ANSWERS: number = 10134;
export const ERROR_USER_TWO_STEP_VERIFICATION_RECOVER_PASSWORD_BY_ANSWERS_NO_PASSWORD: number = 10135;
export const ERROR_USER_TWO_STEP_VERIFICATION_RECOVER_PASSWORD_BY_ANSWERS_FORBIDDEN: number = 10156;

export const ERROR_USER_TWO_STEP_VERIFICATION_CHANGE_RECOVERY_QUESTION_BAD_PAYLOAD: number = 10136;
export const ERROR_USER_TWO_STEP_VERIFICATION_CHANGE_RECOVERY_QUESTION_INTERNAL_SERVER_ERROR: number = 10137;
export const ERROR_USER_TWO_STEP_VERIFICATION_CHANGE_RECOVERY_QUESTION_MAX_TRY_LOCK: number = 10138;
export const ERROR_USER_TWO_STEP_VERIFICATION_CHANGE_RECOVERY_QUESTION_NO_PASSWORD: number = 10139;
export const ERROR_USER_TWO_STEP_VERIFICATION_CHANGE_RECOVERY_QUESTION_INVALID_PASSWORD: number = 10140;

export const ERROR_USER_TWO_STEP_VERIFICATION_CHANGE_HINT_BAD_PAYLOAD: number = 10141;
export const ERROR_USER_TWO_STEP_VERIFICATION_CHANGE_HINT_INTERNAL_SERVER_ERROR: number = 10142;
export const ERROR_USER_TWO_STEP_VERIFICATION_CHANGE_HINT_MAX_TRY_LOCK: number = 10143;
export const ERROR_USER_TWO_STEP_VERIFICATION_CHANGE_HINT_NO_PASSWORD: number = 10144;
export const ERROR_USER_TWO_STEP_VERIFICATION_CHANGE_HINT_INVALID_PASSWORD: number = 10145;

export const ERROR_USER_TWO_STEP_VERIFICATION_RESEND_VERIFY_EMAIL_BAD_PAYLOAD: number = 10157;
export const ERROR_USER_TWO_STEP_VERIFICATION_RESEND_VERIFY_EMAIL_INTERNAL_SERVER_ERROR: number = 10158;
export const ERROR_USER_TWO_STEP_VERIFICATION_RESEND_VERIFY_EMAIL_NO_PASSWORD: number = 10159;
export const ERROR_USER_TWO_STEP_VERIFICATION_RESEND_VERIFY_EMAIL_NO_UNCONFIRMED_RECOVERY_EMAIL: number = 10160;

export const ERROR_USER_PRIVACY_GET_RULE_BAD_PAYLOAD: number = 10146;
export const ERROR_USER_PRIVACY_GET_RULE_INTERNAL_SERVER_ERROR: number = 10147;

export const ERROR_USER_PRIVACY_SET_RULE_BAD_PAYLOAD: number = 10148;
export const ERROR_USER_PRIVACY_SET_RULE_INTERNAL_SERVER_ERROR: number = 10149;

export const ERROR_USER_VERIFY_NEW_DEVICE_BAD_PAYLOAD: number = 10150;
export const ERROR_USER_VERIFY_NEW_DEVICE_INTERNAL_SERVER_ERROR: number = 10151;
export const ERROR_USER_VERIFY_NEW_DEVICE_INVALID_TOKEN: number = 10152;
export const ERROR_USER_VERIFY_NEW_DEVICE_EXPIRED_TOKEN: number = 10153;

export const ERROR_USER_PROFILE_SET_BIO_BAD_PAYLOAD: number = 10161;
export const ERROR_USER_PROFILE_SET_BIO_INTERNAL_SERVER_ERROR: number = 10162;

export const ERROR_USER_PROFILE_GET_BIO_BAD_PAYLOAD: number = 10163;
export const ERROR_USER_PROFILE_GET_BIO_INTERNAL_SERVER_ERROR: number = 10164;

export const ERROR_USER_REPORT_BAD_PAYLOAD: number = 10165;
export const ERROR_USER_REPORT_INTERNAL_SERVER_ERROR: number = 10166;
export const ERROR_USER_REPORT_REPORTED_BEFORE: number = 10167;
export const ERROR_USER_REPORT_FORBIDDEN: number = 10168;

// Chat room errors 2xx

export const ERROR_CHAT_GET_ROOM_BAD_PAYLOAD: number = 200;
export const ERROR_CHAT_GET_ROOM_INTERNAL_SERVER_ERROR: number = 201;
export const ERROR_CHAT_GET_ROOM_PEER_NOT_FOUND: number = 202;

export const ERROR_CHAT_SEND_MESSAGE_BAD_PAYLOAD: number = 203;
export const ERROR_CHAT_SEND_MESSAGE_INTERNAL_SERVER_ERROR: number = 204;
export const ERROR_CHAT_SEND_MESSAGE_FORBIDDEN: number = 205;
export const ERROR_CHAT_SEND_MESSAGE_BLOCKED_BY_PEER: number = 233;
export const ERROR_CHAT_SEND_MESSAGE_LIMIT_REACHED: number = 234;

export const ERROR_CHAT_UPDATE_STATUS_BAD_PAYLOAD: number = 206;
export const ERROR_CHAT_UPDATE_STATUS_INTERNAL_SERVER_ERROR: number = 207;
export const ERROR_CHAT_UPDATE_STATUS_FORBIDDEN: number = 208;

export const ERROR_CHAT_EDIT_MESSAGE_BAD_PAYLOAD: number = 209;
export const ERROR_CHAT_EDIT_MESSAGE_INTERNAL_SERVER_ERROR: number = 210;
export const ERROR_CHAT_EDIT_MESSAGE_FORBIDDEN: number = 211;

export const ERROR_CHAT_DELETE_MESSAGE_BAD_PAYLOAD: number = 212;
export const ERROR_CHAT_DELETE_MESSAGE_INTERNAL_SERVER_ERROR: number = 213;
export const ERROR_CHAT_DELETE_MESSAGE_FORBIDDEN: number = 214;

export const ERROR_CHAT_CLEAR_MESSAGE_BAD_PAYLOAD: number = 215;
export const ERROR_CHAT_CLEAR_MESSAGE_INTERNAL_SERVER_ERROR: number = 216;
export const ERROR_CHAT_CLEAR_MESSAGE_FORBIDDEN: number = 217;

export const ERROR_CHAT_DELETE_BAD_PAYLOAD: number = 218;
export const ERROR_CHAT_DELETE_INTERNAL_SERVER_ERROR: number = 219;
export const ERROR_CHAT_DELETE_FORBIDDEN: number = 220;

export const ERROR_CHAT_UPDATE_DRAFT_BAD_PAYLOAD: number = 221;
export const ERROR_CHAT_UPDATE_DRAFT_INTERNAL_SERVER_ERROR: number = 222;
export const ERROR_CHAT_UPDATE_DRAFT_FORBIDDEN: number = 223;

export const ERROR_CHAT_GET_DRAFT_BAD_PAYLOAD: number = 224;
export const ERROR_CHAT_GET_DRAFT_INTERNAL_SERVER_ERROR: number = 225;
export const ERROR_CHAT_GET_DRAFT_FORBIDDEN: number = 226;

export const ERROR_CHAT_CONVERT_TO_GROUP_BAD_PAYLOAD: number = 227;
export const ERROR_CHAT_CONVERT_TO_GROUP_INTERNAL_SERVER_ERROR: number = 228;
export const ERROR_CHAT_CONVERT_TO_GROUP_FORBIDDEN: number = 229;

export const ERROR_CHAT_SET_ACTION_BAD_PAYLOAD: number = 230;
export const ERROR_CHAT_SET_ACTION_INTERNAL_SERVER_ERROR: number = 231;
export const ERROR_CHAT_SET_ACTION_FORBIDDEN: number = 232;

// Group room errors 3xx

export const ERROR_GROUP_CREATE_BAD_PAYLOAD: number = 300;
export const ERROR_GROUP_CREATE_INTERNAL_SERVER_ERROR: number = 301;
export const ERROR_GROUP_CREATE_LIMIT_REACHED: number = 380;

export const ERROR_GROUP_ADD_MEMBER_BAD_PAYLOAD: number = 302;
export const ERROR_GROUP_ADD_MEMBER_INTERNAL_SERVER_ERROR: number = 303;
export const ERROR_GROUP_ADD_MEMBER_EXISTS: number = 304;
export const ERROR_GROUP_ADD_MEMBER_FORBIDDEN: number = 305;
export const ERROR_GROUP_ADD_MEMBER_PARTICIPANTS_COUNT_LIMIT_EXCEEDED: number = 362;
export const ERROR_GROUP_ADD_MEMBER_PRIVACY_PROTECTION: number = 379;

export const ERROR_GROUP_SEND_MESSAGE_BAD_PAYLOAD: number = 306;
export const ERROR_GROUP_SEND_MESSAGE_INTERNAL_SERVER_ERROR: number = 307;
export const ERROR_GROUP_SEND_MESSAGE_FORBIDDEN: number = 308;

export const ERROR_GROUP_UPDATE_STATUS_BAD_PAYLOAD: number = 309;
export const ERROR_GROUP_UPDATE_STATUS_INTERNAL_SERVER_ERROR: number = 310;
export const ERROR_GROUP_UPDATE_STATUS_FORBIDDEN: number = 311;

export const ERROR_GROUP_DELETE_MESSAGE_BAD_PAYLOAD: number = 312;
export const ERROR_GROUP_DELETE_MESSAGE_INTERNAL_SERVER_ERROR: number = 313;
export const ERROR_GROUP_DELETE_MESSAGE_FORBIDDEN: number = 314;

export const ERROR_GROUP_CLEAR_MESSAGE_BAD_PAYLOAD: number = 315;
export const ERROR_GROUP_CLEAR_MESSAGE_INTERNAL_SERVER_ERROR: number = 316;
export const ERROR_GROUP_CLEAR_MESSAGE_FORBIDDEN: number = 317;

export const ERROR_GROUP_ADD_MODERATOR_BAD_PAYLOAD: number = 318;
export const ERROR_GROUP_ADD_MODERATOR_INTERNAL_SERVER_ERROR: number = 319;
export const ERROR_GROUP_ADD_MODERATOR_FORBIDDEN: number = 320;

export const ERROR_GROUP_ADD_ADMIN_BAD_PAYLOAD: number = 321;
export const ERROR_GROUP_ADD_ADMIN_INTERNAL_SERVER_ERROR: number = 322;
export const ERROR_GROUP_ADD_ADMIN_FORBIDDEN: number = 323;

export const ERROR_GROUP_KICK_MODERATOR_BAD_PAYLOAD: number = 324;
export const ERROR_GROUP_KICK_MODERATOR_INTERNAL_SERVER_ERROR: number = 325;
export const ERROR_GROUP_KICK_MODERATOR_FORBIDDEN: number = 326;

export const ERROR_GROUP_KICK_ADMIN_BAD_PAYLOAD: number = 327;
export const ERROR_GROUP_KICK_ADMIN_INTERNAL_SERVER_ERROR: number = 328;
export const ERROR_GROUP_KICK_ADMIN_FORBIDDEN: number = 329;

export const ERROR_GROUP_EDIT_BAD_PAYLOAD: number = 330;
export const ERROR_GROUP_EDIT_INTERNAL_SERVER_ERROR: number = 331;
export const ERROR_GROUP_EDIT_FORBIDDEN: number = 363;

export const ERROR_GROUP_KICK_MEMBER_BAD_PAYLOAD: number = 332;
export const ERROR_GROUP_KICK_MEMBER_INTERNAL_SERVER_ERROR: number = 333;
export const ERROR_GROUP_KICK_MEMBER_FORBIDDEN: number = 334;

export const ERROR_GROUP_LEFT_BAD_PAYLOAD: number = 335;
export const ERROR_GROUP_LEFT_INTERNAL_SERVER_ERROR: number = 336;
export const ERROR_GROUP_LEFT_FORBIDDEN: number = 337;

export const ERROR_GROUP_AVATAR_ADD_BAD_PAYLOAD: number = 338;
export const ERROR_GROUP_AVATAR_ADD_INTERNAL_SERVER_ERROR: number = 339;
export const ERROR_GROUP_AVATAR_ADD_FORBIDDEN: number = 340;

export const ERROR_GROUP_AVATAR_DELETE_BAD_PAYLOAD: number = 341;
export const ERROR_GROUP_AVATAR_DELETE_INTERNAL_SERVER_ERROR: number = 342;
export const ERROR_GROUP_AVATAR_DELETE_FORBIDDEN: number = 343;

export const ERROR_GROUP_AVATAR_GET_LIST_BAD_PAYLOAD: number = 344;
export const ERROR_GROUP_AVATAR_GET_LIST_INTERNAL_SERVER_ERROR: number = 345;
export const ERROR_GROUP_AVATAR_GET_LIST_FORBIDDEN: number = 346;

export const ERROR_GROUP_UPDATE_DRAFT_BAD_PAYLOAD: number = 347;
export const ERROR_GROUP_UPDATE_DRAFT_INTERNAL_SERVER_ERROR: number = 348;
export const ERROR_GROUP_UPDATE_DRAFT_FORBIDDEN: number = 349;

export const ERROR_GROUP_GET_DRAFT_BAD_PAYLOAD: number = 350;
export const ERROR_GROUP_GET_DRAFT_INTERNAL_SERVER_ERROR: number = 351;
export const ERROR_GROUP_GET_DRAFT_FORBIDDEN: number = 352;

export const ERROR_GROUP_GET_MEMBER_LIST_BAD_PAYLOAD: number = 353;
export const ERROR_GROUP_GET_MEMBER_LIST_INTERNAL_SERVER_ERROR: number = 354;
export const ERROR_GROUP_GET_MEMBER_LIST_FORBIDDEN: number = 355;

export const ERROR_GROUP_DELETE_BAD_PAYLOAD: number = 356;
export const ERROR_GROUP_DELETE_INTERNAL_SERVER_ERROR: number = 357;
export const ERROR_GROUP_DELETE_FORBIDDEN: number = 358;

export const ERROR_GROUP_SET_ACTION_BAD_PAYLOAD: number = 359;
export const ERROR_GROUP_SET_ACTION_INTERNAL_SERVER_ERROR: number = 360;
export const ERROR_GROUP_SET_ACTION_FORBIDDEN: number = 361;

export const ERROR_GROUP_CHECK_USERNAME_BAD_PAYLOAD: number = 364;
export const ERROR_GROUP_CHECK_USERNAME_INTERNAL_SERVER_ERROR: number = 365;

export const ERROR_GROUP_UPDATE_USERNAME_BAD_PAYLOAD: number = 366;
export const ERROR_GROUP_UPDATE_USERNAME_INTERNAL_SERVER_ERROR: number = 367;
export const ERROR_GROUP_UPDATE_USERNAME_UPDATE_LOCK: number = 368;
export const ERROR_GROUP_UPDATE_USERNAME_FORBIDDEN: number = 369;

export const ERROR_GROUP_REMOVE_USERNAME_BAD_PAYLOAD: number = 370;
export const ERROR_GROUP_REMOVE_USERNAME_INTERNAL_SERVER_ERROR: number = 371;
export const ERROR_GROUP_REMOVE_USERNAME_FORBIDDEN: number = 372;

export const ERROR_GROUP_REVOKE_LINK_BAD_PAYLOAD: number = 373;
export const ERROR_GROUP_REVOKE_LINK_INTERNAL_SERVER_ERROR: number = 374;
export const ERROR_GROUP_REVOKE_LINK_FORBIDDEN: number = 375;

export const ERROR_GROUP_EDIT_MESSAGE_BAD_PAYLOAD: number = 376;
export const ERROR_GROUP_EDIT_MESSAGE_INTERNAL_SERVER_ERROR: number = 377;
export const ERROR_GROUP_EDIT_MESSAGE_FORBIDDEN: number = 378;

export const ERROR_GROUP_PIN_MESSAGE_BAD_PAYLOAD: number = 381;
export const ERROR_GROUP_PIN_MESSAGE_INTERNAL_SERVER_ERROR: number = 382;
export const ERROR_GROUP_PIN_MESSAGE_FORBIDDEN: number = 383;

// Channel room errors 4xx

export const ERROR_CHANNEL_CREATE_BAD_PAYLOAD: number = 400;
export const ERROR_CHANNEL_CREATE_INTERNAL_SERVER_ERROR: number = 401;
export const ERROR_CHANNEL_CREATE_LIMIT_REACHED: number = 479;

export const ERROR_CHANNEL_ADD_MEMBER_BAD_PAYLOAD: number = 402;
export const ERROR_CHANNEL_ADD_MEMBER_INTERNAL_SERVER_ERROR: number = 403;
export const ERROR_CHANNEL_ADD_MEMBER_EXISTS: number = 404;
export const ERROR_CHANNEL_ADD_MEMBER_FORBIDDEN: number = 405;
export const ERROR_CHANNEL_ADD_MEMBER_PRIVACY_PROTECTION: number = 478;

export const ERROR_CHANNEL_SEND_MESSAGE_BAD_PAYLOAD: number = 406;
export const ERROR_CHANNEL_SEND_MESSAGE_INTERNAL_SERVER_ERROR: number = 407;
export const ERROR_CHANNEL_SEND_MESSAGE_FORBIDDEN: number = 408;

export const ERROR_CHANNEL_DELETE_BAD_PAYLOAD: number = 409;
export const ERROR_CHANNEL_DELETE_INTERNAL_SERVER_ERROR: number = 410;
export const ERROR_CHANNEL_DELETE_FORBIDDEN: number = 411;

export const ERROR_CHANNEL_DELETE_MESSAGE_BAD_PAYLOAD: number = 412;
export const ERROR_CHANNEL_DELETE_MESSAGE_INTERNAL_SERVER_ERROR: number = 413;
export const ERROR_CHANNEL_DELETE_MESSAGE_FORBIDDEN: number = 414;

export const ERROR_CHANNEL_GET_MEMBER_LIST_BAD_PAYLOAD: number = 415;
export const ERROR_CHANNEL_GET_MEMBER_LIST_INTERNAL_SERVER_ERROR: number = 416;
export const ERROR_CHANNEL_GET_MEMBER_LIST_FORBIDDEN: number = 417;

export const ERROR_CHANNEL_ADD_MODERATOR_BAD_PAYLOAD: number = 418;
export const ERROR_CHANNEL_ADD_MODERATOR_INTERNAL_SERVER_ERROR: number = 419;
export const ERROR_CHANNEL_ADD_MODERATOR_FORBIDDEN: number = 420;

export const ERROR_CHANNEL_ADD_ADMIN_BAD_PAYLOAD: number = 421;
export const ERROR_CHANNEL_ADD_ADMIN_INTERNAL_SERVER_ERROR: number = 422;
export const ERROR_CHANNEL_ADD_ADMIN_FORBIDDEN: number = 423;

export const ERROR_CHANNEL_KICK_MODERATOR_BAD_PAYLOAD: number = 424;
export const ERROR_CHANNEL_KICK_MODERATOR_INTERNAL_SERVER_ERROR: number = 425;
export const ERROR_CHANNEL_KICK_MODERATOR_FORBIDDEN: number = 426;

export const ERROR_CHANNEL_KICK_ADMIN_BAD_PAYLOAD: number = 427;
export const ERROR_CHANNEL_KICK_ADMIN_INTERNAL_SERVER_ERROR: number = 428;
export const ERROR_CHANNEL_KICK_ADMIN_FORBIDDEN: number = 429;

export const ERROR_CHANNEL_EDIT_BAD_PAYLOAD: number = 430;
export const ERROR_CHANNEL_EDIT_INTERNAL_SERVER_ERROR: number = 431;
export const ERROR_CHANNEL_EDIT_FORBIDDEN: number = 459;

export const ERROR_CHANNEL_KICK_MEMBER_BAD_PAYLOAD: number = 432;
export const ERROR_CHANNEL_KICK_MEMBER_INTERNAL_SERVER_ERROR: number = 433;
export const ERROR_CHANNEL_KICK_MEMBER_FORBIDDEN: number = 434;

export const ERROR_CHANNEL_LEFT_BAD_PAYLOAD: number = 435;
export const ERROR_CHANNEL_LEFT_INTERNAL_SERVER_ERROR: number = 436;
export const ERROR_CHANNEL_LEFT_FORBIDDEN: number = 437;

export const ERROR_CHANNEL_AVATAR_ADD_BAD_PAYLOAD: number = 438;
export const ERROR_CHANNEL_AVATAR_ADD_INTERNAL_SERVER_ERROR: number = 439;
export const ERROR_CHANNEL_AVATAR_ADD_FORBIDDEN: number = 440;

export const ERROR_CHANNEL_AVATAR_DELETE_BAD_PAYLOAD: number = 441;
export const ERROR_CHANNEL_AVATAR_DELETE_INTERNAL_SERVER_ERROR: number = 442;
export const ERROR_CHANNEL_AVATAR_DELETE_FORBIDDEN: number = 443;

export const ERROR_CHANNEL_AVATAR_GET_LIST_BAD_PAYLOAD: number = 444;
export const ERROR_CHANNEL_AVATAR_GET_LIST_INTERNAL_SERVER_ERROR: number = 445;
export const ERROR_CHANNEL_AVATAR_GET_LIST_FORBIDDEN: number = 446;

export const ERROR_CHANNEL_UPDATE_DRAFT_BAD_PAYLOAD: number = 447;
export const ERROR_CHANNEL_UPDATE_DRAFT_INTERNAL_SERVER_ERROR: number = 448;
export const ERROR_CHANNEL_UPDATE_DRAFT_FORBIDDEN: number = 449;

export const ERROR_CHANNEL_GET_DRAFT_BAD_PAYLOAD: number = 450;
export const ERROR_CHANNEL_GET_DRAFT_INTERNAL_SERVER_ERROR: number = 451;
export const ERROR_CHANNEL_GET_DRAFT_FORBIDDEN: number = 452;

export const ERROR_CHANNEL_CHECK_USERNAME_BAD_PAYLOAD: number = 453;
export const ERROR_CHANNEL_CHECK_USERNAME_INTERNAL_SERVER_ERROR: number = 454;

export const ERROR_CHANNEL_UPDATE_USERNAME_BAD_PAYLOAD: number = 455;
export const ERROR_CHANNEL_UPDATE_USERNAME_INTERNAL_SERVER_ERROR: number = 456;
export const ERROR_CHANNEL_UPDATE_USERNAME_UPDATE_LOCK: number = 457;
export const ERROR_CHANNEL_UPDATE_USERNAME_FORBIDDEN: number = 458;

export const ERROR_CHANNEL_REMOVE_USERNAME_BAD_PAYLOAD: number = 460;
export const ERROR_CHANNEL_REMOVE_USERNAME_INTERNAL_SERVER_ERROR: number = 461;
export const ERROR_CHANNEL_REMOVE_USERNAME_FORBIDDEN: number = 462;

export const ERROR_CHANNEL_REVOKE_LINK_BAD_PAYLOAD: number = 463;
export const ERROR_CHANNEL_REVOKE_LINK_INTERNAL_SERVER_ERROR: number = 464;
export const ERROR_CHANNEL_REVOKE_LINK_FORBIDDEN: number = 465;

export const ERROR_CHANNEL_UPDATE_SIGNATURE_BAD_PAYLOAD: number = 466;
export const ERROR_CHANNEL_UPDATE_SIGNATURE_INTERNAL_SERVER_ERROR: number = 467;
export const ERROR_CHANNEL_UPDATE_SIGNATURE_FORBIDDEN: number = 468;

export const ERROR_CHANNEL_GET_MESSAGES_STATS_BAD_PAYLOAD: number = 469;
export const ERROR_CHANNEL_GET_MESSAGES_STATS_INTERNAL_SERVER_ERROR: number = 470;
export const ERROR_CHANNEL_GET_MESSAGES_STATS_FORBIDDEN: number = 471;

export const ERROR_CHANNEL_ADD_MESSAGE_REACTION_BAD_PAYLOAD: number = 472;
export const ERROR_CHANNEL_ADD_MESSAGE_REACTION_INTERNAL_SERVER_ERROR: number = 473;
export const ERROR_CHANNEL_ADD_MESSAGE_REACTION_FORBIDDEN: number = 474;

export const ERROR_CHANNEL_EDIT_MESSAGE_BAD_PAYLOAD: number = 475;
export const ERROR_CHANNEL_EDIT_MESSAGE_INTERNAL_SERVER_ERROR: number = 476;
export const ERROR_CHANNEL_EDIT_MESSAGE_FORBIDDEN: number = 477;

export const ERROR_CHANNEL_UPDATE_REACTION_STATUS_BAD_PAYLOAD: number = 480;
export const ERROR_CHANNEL_UPDATE_REACTION_STATUS_INTERNAL_SERVER_ERROR: number = 481;
export const ERROR_CHANNEL_UPDATE_REACTION_STATUS_FORBIDDEN: number = 482;

export const ERROR_CHANNEL_PIN_MESSAGE_BAD_PAYLOAD: number = 483;
export const ERROR_CHANNEL_PIN_MESSAGE_INTERNAL_SERVER_ERROR: number = 484;
export const ERROR_CHANNEL_PIN_MESSAGE_FORBIDDEN: number = 485;

// Info errors 5xx

export const ERROR_INFO_LOCATION_NOT_FOUND: number = 500;

export const ERROR_INFO_COUNTRY_BAD_PAYLOAD: number = 501;

export const ERROR_INFO_PAGE_BAD_PAYLOAD: number = 502;
export const ERROR_INFO_PAGE_INTERNAL_SERVER_ERROR: number = 503;

export const ERROR_INFO_WALLPAPER_BAD_PAYLOAD: number = 504;
export const ERROR_INFO_WALLPAPER_INTERNAL_SERVER_ERROR: number = 505;

// Client errors 6xx

export const ERROR_CLIENT_CONDITION_BAD_PAYLOAD: number = 600;
export const ERROR_CLIENT_CONDITION_INTERNAL_SERVER_ERROR: number = 601;

export const ERROR_CLIENT_UPDATE_MESSAGE_BAD_PAYLOAD: number = 602;
export const ERROR_CLIENT_UPDATE_MESSAGE_INTERNAL_SERVER_ERROR: number = 603;
export const ERROR_CLIENT_UPDATE_MESSAGE_FORBIDDEN: number = 604;

export const ERROR_CLIENT_UPDATE_DELETE_MESSAGE_BAD_PAYLOAD: number = 605;
export const ERROR_CLIENT_UPDATE_DELETE_MESSAGE_INTERNAL_SERVER_ERROR: number = 606;

export const ERROR_CLIENT_UPDATE_MESSAGE_STATUS_BAD_PAYLOAD: number = 607;
export const ERROR_CLIENT_UPDATE_MESSAGE_STATUS_INTERNAL_SERVER_ERROR: number = 608;
export const ERROR_CLIENT_UPDATE_MESSAGE_STATUS_FORBIDDEN: number = 609;

export const ERROR_CLIENT_GET_ROOM_LIST_BAD_PAYLOAD: number = 610;
export const ERROR_CLIENT_GET_ROOM_LIST_INTERNAL_SERVER_ERROR: number = 611;

export const ERROR_CLIENT_GET_ROOM_BAD_PAYLOAD: number = 612;
export const ERROR_CLIENT_GET_ROOM_INTERNAL_SERVER_ERROR: number = 613;
export const ERROR_CLIENT_GET_ROOM_NOT_FOUND: number = 614;

export const ERROR_CLIENT_GET_ROOM_HISTORY_BAD_PAYLOAD: number = 615;
export const ERROR_CLIENT_GET_ROOM_HISTORY_INTERNAL_SERVER_ERROR: number = 616;
export const ERROR_CLIENT_GET_ROOM_HISTORY_NOT_FOUND: number = 617;

export const ERROR_CLIENT_SEARCH_ROOM_HISTORY_BAD_PAYLOAD: number = 618;
export const ERROR_CLIENT_SEARCH_ROOM_HISTORY_INTERNAL_SERVER_ERROR: number = 619;
export const ERROR_CLIENT_SEARCH_ROOM_HISTORY_NOT_FOUND: number = 620;

export const ERROR_CLIENT_RESOLVE_USERNAME_BAD_PAYLOAD: number = 621;
export const ERROR_CLIENT_RESOLVE_USERNAME_INTERNAL_SERVER_ERROR: number = 622;
export const ERROR_CLIENT_RESOLVE_USERNAME_NOT_FOUND: number = 623;

export const ERROR_CLIENT_GET_ROOM_MESSAGE_BAD_PAYLOAD: number = 624;
export const ERROR_CLIENT_GET_ROOM_MESSAGE_INTERNAL_SERVER_ERROR: number = 625;
export const ERROR_CLIENT_GET_ROOM_MESSAGE_NOT_FOUND: number = 626;

export const ERROR_CLIENT_CHECK_INVITE_LINK_BAD_PAYLOAD: number = 627;
export const ERROR_CLIENT_CHECK_INVITE_LINK_INTERNAL_SERVER_ERROR: number = 628;
export const ERROR_CLIENT_CHECK_INVITE_LINK_NOT_FOUND: number = 629;

export const ERROR_CLIENT_JOIN_BY_INVITE_LINK_BAD_PAYLOAD: number = 630;
export const ERROR_CLIENT_JOIN_BY_INVITE_LINK_INTERNAL_SERVER_ERROR: number = 631;
export const ERROR_CLIENT_JOIN_BY_INVITE_LINK_FORBIDDEN: number = 632;
export const ERROR_CLIENT_JOIN_BY_INVITE_LINK_ALREADY_JOINED: number = 633;
export const ERROR_CLIENT_JOIN_BY_INVITE_LINK_PARTICIPANTS_COUNT_LIMIT_EXCEEDED: number = 634;

export const ERROR_CLIENT_JOIN_BY_USERNAME_BAD_PAYLOAD: number = 635;
export const ERROR_CLIENT_JOIN_BY_USERNAME_INTERNAL_SERVER_ERROR: number = 636;
export const ERROR_CLIENT_JOIN_BY_USERNAME_FORBIDDEN: number = 637;
export const ERROR_CLIENT_JOIN_BY_USERNAME_ALREADY_JOINED: number = 638;
export const ERROR_CLIENT_JOIN_BY_USERNAME_PARTICIPANTS_COUNT_LIMIT_EXCEEDED: number = 639;

export const ERROR_CLIENT_SUBSCRIBE_TO_ROOM_BAD_PAYLOAD: number = 640;
export const ERROR_CLIENT_SUBSCRIBE_TO_ROOM_INTERNAL_SERVER_ERROR: number = 641;
export const ERROR_CLIENT_SUBSCRIBE_TO_ROOM_FORBIDDEN: number = 642;

export const ERROR_CLIENT_UNSUBSCRIBE_FROM_ROOM_BAD_PAYLOAD: number = 643;
export const ERROR_CLIENT_UNSUBSCRIBE_FROM_ROOM_INTERNAL_SERVER_ERROR: number = 644;

export const ERROR_CLIENT_SEARCH_USERNAME_BAD_PAYLOAD: number = 645;
export const ERROR_CLIENT_SEARCH_USERNAME_INTERNAL_SERVER_ERROR: number = 646;

export const ERROR_CLIENT_COUNT_ROOM_HISTORY_BAD_PAYLOAD: number = 647;
export const ERROR_CLIENT_COUNT_ROOM_HISTORY_INTERNAL_SERVER_ERROR: number = 648;
export const ERROR_CLIENT_COUNT_ROOM_HISTORY_NOT_FOUND: number = 649;

export const ERROR_CLIENT_MUTE_ROOM_BAD_PAYLOAD: number = 650;
export const ERROR_CLIENT_MUTE_ROOM_INTERNAL_SERVER_ERROR: number = 651;
export const ERROR_CLIENT_MUTE_ROOM_FORBIDDEN: number = 652;

export const ERROR_CLIENT_PIN_ROOM_BAD_PAYLOAD: number = 653;
export const ERROR_CLIENT_PIN_ROOM_INTERNAL_SERVER_ERROR: number = 654;
export const ERROR_CLIENT_PIN_ROOM_FORBIDDEN: number = 655;

export const ERROR_CLIENT_ROOM_REPORT_BAD_PAYLOAD: number = 656;
export const ERROR_CLIENT_ROOM_REPORT_INTERNAL_SERVER_ERROR: number = 657;
export const ERROR_CLIENT_ROOM_REPORT_REPORTED_BEFORE: number = 658;
export const ERROR_CLIENT_ROOM_REPORT_FORBIDDEN: number = 659;
export const ERROR_CLIENT_REGISTER_DEVICE_BAD_PAYLOAD: number = 660;
export const ERROR_CLIENT_REGISTER_DEVICE_INTERNAL_SERVER_ERROR: number = 661;
export const ERROR_CLIENT_REGISTER_DEVICE_FORBIDDEN: number = 662;

// File errors 7xx

export const ERROR_FILE_UPLOAD_OPTION_BAD_PAYLOAD: number = 700;
export const ERROR_FILE_UPLOAD_OPTION_INTERNAL_SERVER_ERROR: number = 701;

export const ERROR_FILE_UPLOAD_INIT_BAD_PAYLOAD: number = 702;
export const ERROR_FILE_UPLOAD_INIT_INTERNAL_SERVER_ERROR: number = 703;

export const ERROR_FILE_UPLOAD_BAD_PAYLOAD: number = 704;
export const ERROR_FILE_UPLOAD_INTERNAL_SERVER_ERROR: number = 705;
export const ERROR_FILE_UPLOAD_FORBIDDEN: number = 706;

export const ERROR_FILE_UPLOAD_STATUS_BAD_PAYLOAD: number = 707;
export const ERROR_FILE_UPLOAD_STATUS_INTERNAL_SERVER_ERROR: number = 708;
export const ERROR_FILE_UPLOAD_STATUS_NOT_FOUND: number = 709;

export const ERROR_FILE_INFO_BAD_PAYLOAD: number = 710;
export const ERROR_FILE_INFO_INTERNAL_SERVER_ERROR: number = 711;
export const ERROR_FILE_INFO_NOT_FOUND: number = 712;

export const ERROR_FILE_DOWNLOAD_BAD_PAYLOAD: number = 713;
export const ERROR_FILE_DOWNLOAD_INTERNAL_SERVER_ERROR: number = 714;
export const ERROR_FILE_DOWNLOAD_NOT_FOUND: number = 715;

// QR code errors 7xx

export const ERROR_QR_CODE_JOIN_BAD_PAYLOAD: number = 800;
export const ERROR_QR_CODE_JOIN_INTERNAL_SERVER_ERROR: number = 801;

export const ERROR_QR_CODE_RESOLVE_BAD_PAYLOAD: number = 802;
export const ERROR_QR_CODE_RESOLVE_INTERNAL_SERVER_ERROR: number = 803;

export const ERROR_QR_CODE_NEW_DEVICE_BAD_PAYLOAD: number = 804;
export const ERROR_QR_CODE_NEW_DEVICE_INTERNAL_SERVER_ERROR: number = 805;

export const ERROR_QR_CODE_ADD_CONTACT_BAD_PAYLOAD: number = 806;
export const ERROR_QR_CODE_ADD_CONTACT_INTERNAL_SERVER_ERROR: number = 807;

export const ERROR_QR_CODE_ADD_ME_BAD_PAYLOAD: number = 808;
export const ERROR_QR_CODE_ADD_ME_INTERNAL_SERVER_ERROR: number = 809;

// Signaling errors 9xx

export const ERROR_SIGNALING_GET_CONFIGURATION_BAD_PAYLOAD: number = 900;
export const ERROR_SIGNALING_GET_CONFIGURATION_INTERNAL_SERVER_ERROR: number = 901;

export const ERROR_SIGNALING_OFFER_BAD_PAYLOAD: number = 902;
export const ERROR_SIGNALING_OFFER_INTERNAL_SERVER_ERROR: number = 903;
export const ERROR_SIGNALING_OFFER_FORBIDDEN: number = 904;
export const ERROR_SIGNALING_OFFER_BLOCKED_BY_PEER: number = 905;
export const ERROR_SIGNALING_OFFER_PRIVACY_PROTECTION: number = 906;

export const ERROR_SIGNALING_RINGING_BAD_PAYLOAD: number = 907;
export const ERROR_SIGNALING_RINGING_INTERNAL_SERVER_ERROR: number = 908;
export const ERROR_SIGNALING_RINGING_FORBIDDEN: number = 909;

export const ERROR_SIGNALING_ACCEPT_BAD_PAYLOAD: number = 910;
export const ERROR_SIGNALING_ACCEPT_INTERNAL_SERVER_ERROR: number = 911;
export const ERROR_SIGNALING_ACCEPT_FORBIDDEN: number = 912;

export const ERROR_SIGNALING_CANDIDATE_BAD_PAYLOAD: number = 913;
export const ERROR_SIGNALING_CANDIDATE_INTERNAL_SERVER_ERROR: number = 914;
export const ERROR_SIGNALING_CANDIDATE_FORBIDDEN: number = 915;

export const ERROR_SIGNALING_LEAVE_BAD_PAYLOAD: number = 916;
export const ERROR_SIGNALING_LEAVE_INTERNAL_SERVER_ERROR: number = 917;
export const ERROR_SIGNALING_LEAVE_FORBIDDEN: number = 918;

export const ERROR_SIGNALING_SESSION_HOLD_BAD_PAYLOAD: number = 919;
export const ERROR_SIGNALING_SESSION_HOLD_INTERNAL_SERVER_ERROR: number = 920;
export const ERROR_SIGNALING_SESSION_HOLD_FORBIDDEN: number = 921;

export const ERROR_SIGNALING_GET_LOG_BAD_PAYLOAD: number = 922;
export const ERROR_SIGNALING_GET_LOG_INTERNAL_SERVER_ERROR: number = 923;

export const ERROR_SIGNALING_CLEAR_LOG_BAD_PAYLOAD: number = 924;
export const ERROR_SIGNALING_CLEAR_LOG_INTERNAL_SERVER_ERROR: number = 925;

export const ERROR_SIGNALING_RATE_BAD_PAYLOAD: number = 926;
export const ERROR_SIGNALING_RATE_INTERNAL_SERVER_ERROR: number = 927;
export const ERROR_SIGNALING_RATE_FORBIDDEN: number = 928;

// Geo errors 10xx

export const ERROR_GEO_GET_REGISTER_STATUS_BAD_PAYLOAD: number = 1000;
export const ERROR_GEO_GET_REGISTER_STATUS_INTERNAL_SERVER_ERROR: number = 1001;

export const ERROR_GEO_REGISTER_BAD_PAYLOAD: number = 1002;
export const ERROR_GEO_REGISTER_INTERNAL_SERVER_ERROR: number = 1003;

export const ERROR_GEO_UPDATE_POSITION_BAD_PAYLOAD: number = 1004;
export const ERROR_GEO_UPDATE_POSITION_INTERNAL_SERVER_ERROR: number = 1005;
export const ERROR_GEO_UPDATE_POSITION_FORBIDDEN: number = 1006;

export const ERROR_GEO_GET_COMMENT_BAD_PAYLOAD: number = 1007;
export const ERROR_GEO_GET_COMMENT_INTERNAL_SERVER_ERROR: number = 1008;
export const ERROR_GEO_GET_COMMENT_FORBIDDEN: number = 1009;

export const ERROR_GEO_UPDATE_COMMENT_BAD_PAYLOAD: number = 1010;
export const ERROR_GEO_UPDATE_COMMENT_INTERNAL_SERVER_ERROR: number = 1011;
export const ERROR_GEO_UPDATE_COMMENT_FORBIDDEN: number = 1012;

export const ERROR_GEO_GET_NEARBY_DISTANCE_BAD_PAYLOAD: number = 1013;
export const ERROR_GEO_GET_NEARBY_DISTANCE_INTERNAL_SERVER_ERROR: number = 1014;
export const ERROR_GEO_GET_NEARBY_DISTANCE_FORBIDDEN: number = 1015;

export const ERROR_GEO_GET_NEARBY_COORDINATE_BAD_PAYLOAD: number = 1016;
export const ERROR_GEO_GET_NEARBY_COORDINATE_INTERNAL_SERVER_ERROR: number = 1017;
export const ERROR_GEO_GET_NEARBY_COORDINATE_FORBIDDEN: number = 1018;

export const ERROR_GEO_GET_CONFIGURATION_BAD_PAYLOAD: number = 1019;
export const ERROR_GEO_GET_CONFIGURATION_INTERNAL_SERVER_ERROR: number = 1020;
